/**
 * A class for generic modal dialogs.
 */
class ModalGeneric {

  /**
   * @constructor
   *
   */
  constructor() {
    this.#initOpenListeners();
    this.#initCloseListeners();
  }

  /**
   * Initialize open listeners for buttons
   */  
  #initOpenListeners() {
    const openButtons = document.querySelectorAll('.modal-generic__open');
    for (const button of openButtons) {
      button.addEventListener('click', (e) => {
        const modalId = event?.target?.dataset?.target;
        if (!modalId) {
          console.error('Target not specified');
          return;          
        }
        const modal = document.querySelector(`#${modalId}`);
        if (!modal) {
          console.error('Modal not found');
          return;
        }

        modal.showModal();
      });
    }
  }

  /**
   * Initialize close listeners for buttons
   */  
  #initCloseListeners() {
    const closeButtons = document.querySelectorAll('.modal-generic__close');
    for (const button of closeButtons) {
      button.addEventListener('click', (e) => {
        const modal = event.target.closest('dialog');
        modal.close();
      });
    }
  }
}

export default ModalGeneric;
